export class SelectorErrorCode
{
	static NOT_SELECTED_STORE: string = 'NOT_SELECTED_STORE';
}